import React from 'react';
import { NameSection, SectionWrapper, Subtitle, Title } from './styled';
import OkIcon from 'assets/svg/check-filled.svg';
import { noop } from 'lodash';

interface ICommonProps {
  title: string;
  text?: string;
  isActive: boolean;
  isSaved: boolean;
  children: React.ReactElement;
  selfClick: () => void;
}

export const CommonWrapper: React.FC<ICommonProps> = ({ title, text, isActive, isSaved, children, selfClick }) => {
  return (
    <SectionWrapper>
      <NameSection isActive={isActive} isSaved={isSaved} onClick={isSaved ? selfClick : noop}>
        {isSaved && !isActive ? <OkIcon /> : null}
        <Title isActive={isActive} isSaved={isSaved}>{title}</Title>
        {text && isActive ? <Subtitle>{text}</Subtitle> : null}
      </NameSection>
      {isActive ? children : null}
    </SectionWrapper>
  );
};
